import { h } from 'preact'
import Icon from '../assets'
import Switcher from '../control/Switcher'
import Textarea from '../ui-components/Textarea'
import { ActionButtons, InformationCallout, PanelHeaderWithIcon } from '../registration-rules/PanelItems'
import Tooltip from '../ui-components/Tooltip'

interface BodyProps {
    isKeywordBlockerEnabled: boolean,
    showActionButtons: boolean,
    showValidationError: boolean,
    blockedWords?: Array<string>,
    onSave: () => void,
    onCancel: () => void,
    onTextareaFocus: () => void,
    onKeywordBlockerSettingChanged: (value: boolean) => void,
    onBlockedWordsChanged: (value: string) => void
}

export const KeywordBlockerPanelBody = ({ isKeywordBlockerEnabled, blockedWords, showActionButtons, showValidationError, onSave, onCancel, onTextareaFocus, onKeywordBlockerSettingChanged, onBlockedWordsChanged } : BodyProps) => (
  <div className='panel-body-container'>
    <InformationCallout
      text={`Users with the following roles are excluded from the filter: Administrator, Community Manager, Moderator, Superuser.`} />
    <div className='panel-switch-textarea-container'>
      <div className='switch-icon-container'>
        <Switcher
          on={isKeywordBlockerEnabled}
          customClass='panel-switch'
          labelCustomClass='panel-switch-label'
          label={`Topics and replies containing any of the following keywords will be sent to the pending posts and require moderator approval before they'll be visible. End users who create content with a matching keyword will see a message that explains that their post is pending moderator approval. (separated keywords by comma, e.g. moderator, staff).`}
          onChange={() => onKeywordBlockerSettingChanged(!isKeywordBlockerEnabled)} />
        <Tooltip
          withArrow
          position='right'
          trigger={<Icon customClass='icon-help' icon='help' />}
          customClasses='panel-help-tooltip tooltip-message--right'
          tooltipMessage={`This filter uses an exact match (e.g the 'duck' keyword will match 'duck' but not 'ducking', 'ducked', or 'duck123'`}
        />
      </div>
      <div className='panel-textarea-container'>
        <Textarea
          value={blockedWords?.join(', ')}
          disabled={!isKeywordBlockerEnabled}
          newStyle
          verticalResize
          placeholder='Add keywords...'
          onTextareaFocus={() => onTextareaFocus()}
          onContentChange={(value: string) => onBlockedWordsChanged(value.trim())}
          class={`panel-text-area ${showValidationError ? 'panel-text-area-error' : ''} `}
        />
        {showValidationError &&
        <div className='error-message-container'>
          <div><Icon customClass='icon-warning' icon='warning' /></div>
          <div className='error-message'>Please fill in the required field</div>
        </div>
        }
      </div>
    </div>
    {showActionButtons &&
    <ActionButtons
      onSave={() => onSave()}
      onCancel={() => onCancel()} />
    }
  </div>
)

export const KeywordBlockerPanelHeader = ({ statusText } : { statusText: string }) => (
  <PanelHeaderWithIcon
    customClass='panel-header-container'
    iconCustomClass='icon-panel-header'
    icon='keywordBlocker'
    title='Keyword blocker'
    statusText={statusText} />
)
